export default {
  pages: {
    key: 'title',
    data: [
      // DASHBOARD
      {
        title: 'Dashboard',
        url: '/',
        icon: 'HomeIcon',
        is_bookmarked: true,
        rule: 'dashboard'
      },

      // ADMIN
      {
        title: 'Usuários',
        url: '/users',
        icon: 'UserIcon',
        rule: 'users.menu',
        is_bookmarked: false
      },
      {
        title: 'Grupos',
        url: '/roles',
        icon: 'PackageIcon',
        rule: 'roles.menu',
        is_bookmarked: false
      },
      {
        title: 'Cadastrar Usuário',
        url: '/users/create',
        icon: 'UserIcon',
        rule: 'users.create',
        is_bookmarked: false
      },
      {
        title: 'Cadastrar Grupo',
        url: '/roles/create',
        icon: 'PackageIcon',
        rule: 'roles.create',
        is_bookmarked: false
      },
      {
        title: 'Monitoramento — Dashboard',
        url: '/security/dashboard',
        icon: 'BarChartIcon',
        rule: 'security.dashboard',
        is_bookmarked: false
      },
      {
        title: 'Monitoramento — Logs de acesso',
        url: '/user-access-logs',
        icon: 'LogInIcon',
        rule: 'user_access_logs.menu',
        is_bookmarked: false
      },
      {
        title: 'Monitoramento — Requisições',
        url: '/security/requests',
        icon: 'FileTextIcon',
        rule: 'security.requests.view',
        is_bookmarked: false
      },
      {
        title: 'Monitoramento — Análise de IP',
        url: '/security/ips',
        icon: 'GlobeIcon',
        rule: 'security.ips.view',
        is_bookmarked: false
      },
      {
        title: 'Monitoramento — IPs bloqueados',
        url: '/security/blocked-ips',
        icon: 'LockIcon',
        rule: 'security.blocked_ips.view',
        is_bookmarked: false
      },
      {
        title: 'Integração — Acessos S2S',
        url: '/integrations',
        icon: 'KeyIcon',
        rule: 'integrations.menu',
        is_bookmarked: false
      },
      {
        title: 'Nova integração S2S',
        url: '/integrations/create',
        icon: 'LinkIcon',
        rule: 'integrations.create',
        is_bookmarked: false
      },
      {
        title: 'Integração — URLs',
        url: '/integration-urls',
        icon: 'GlobeIcon',
        rule: 'integrations.menu',
        is_bookmarked: false
      },
      {
        title: 'Nova URL de integração',
        url: '/integration-urls/create',
        icon: 'GlobeIcon',
        rule: 'integrations.create',
        is_bookmarked: false
      },
      {
        title: 'Pessoa Natural',
        url: '/people/natural_entities',
        icon: 'UsersIcon',
        is_bookmarked: true
      },
      {
        title: 'Pessoa Jurídica',
        url: '/people/legal_entities',
        icon: 'UsersIcon',
        is_bookmarked: true
      },
      {
        title: 'Cadastrar Pessoa Jurídica',
        url: '/people/legal_entities/create',
        icon: 'UsersIcon',
        is_bookmarked: true
      },
    ]
  }
}
/* eslint-enable */
